import { useEffect, useState } from "react";
import { X, Share, PlusSquare, Download } from "lucide-react";

const KEY = "tdl-install-dismissed";
const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const isPhone = () => window.matchMedia?.("(max-width: 820px)").matches;

// Small, dismissible "Add to Home Screen" card for phones.
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone() || !isPhone() || localStorage.getItem(KEY) || /^\/(kiosk|checkin|p\/|tracker-signup|inquiry)/.test(window.location.pathname)) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const t = isIos() ? setTimeout(() => setShow(true), 4000) : null;
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); if (t) clearTimeout(t); };
  }, []);

  const dismiss = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => null);
    dismiss();
  };

  if (!show) return null;
  return (
    <div className="fixed inset-x-3 bottom-16 z-[70] rounded-xl p-4 shadow-2xl social-in" style={{ background: "var(--bg-deep)", border: "1px solid var(--gold)" }} data-testid="install-prompt">
      <div className="flex items-start gap-3">
        <img src="/icon-192.png" alt="" className="w-11 h-11 rounded-xl shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium" style={{ color: "var(--ink)" }}>Get the app</div>
          {deferred ? (
            <p className="text-xs mt-0.5" style={{ color: "var(--ink-2)" }}>Add The Disciple Life to your home screen for one-tap access.</p>
          ) : (
            <p className="text-xs mt-0.5 leading-relaxed" style={{ color: "var(--ink-2)" }} data-testid="install-ios-steps">
              Tap <Share size={12} className="inline -mt-0.5" /> <strong>Share</strong>, then <PlusSquare size={12} className="inline -mt-0.5" /> <strong>Add to Home Screen</strong>.
            </p>
          )}
          {deferred && (
            <button onClick={install} className="btn-primary mt-3" style={{ padding: "0.45rem 1rem" }} data-testid="install-prompt-btn"><Download size={13} /> Install</button>
          )}
        </div>
        <button onClick={dismiss} className="p-1 shrink-0" style={{ color: "var(--muted)" }} aria-label="Dismiss" data-testid="install-prompt-dismiss"><X size={16} /></button>
      </div>
    </div>
  );
}
